import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Error from './components/Error';
import ScrollToTop from './components/Helper/ScrollToTop';
import HomeDark from './components/HomeDark';

function Routes() {
    return (
        <>
            <div>
                <Router>
                    <ScrollToTop>
                        <Switch>
                            <Route exact path="/" component={HomeDark} />,
                            <Route component={Error} />
                        </Switch>
                    </ScrollToTop>
                </Router>
            </div>
        </>
    );
}

export default Routes;
